import { Icon } from '@cds/icon';

import { useAiPanelChatScroll } from '../../../hooks/use-ai-panel-chat-scroll';
import type { AiPanelMessage } from '../../../types/ai-panel.types';
import AiAnswer from '../ai-answer/ai-answer';
import AiPanelEmptyChat from '../ai-panel-empty-chat/ai-panel-empty-chat';
import UserMessage from '../user-message/user-message';

import * as styles from './ai-panel-chat.css';

interface AiPanelChatProps {
  messages: AiPanelMessage[];
  isAnswerLoading: boolean;
  answerGeneratingMemoCount: number;
  onRegenerate: (messageId: string) => void;
  onSaveToMemo: (messageId: string) => void;
}

const AiPanelChat = ({
  messages,
  isAnswerLoading,
  answerGeneratingMemoCount,
  onRegenerate,
  onSaveToMemo,
}: AiPanelChatProps) => {
  const { chatAreaRef, setAnswerRef } = useAiPanelChatScroll({
    messages,
    isAnswerLoading,
  });

  return (
    <div ref={chatAreaRef} className={styles.chatArea}>
      {messages.length === 0 ? (
        <AiPanelEmptyChat />
      ) : (
        messages.map((message) =>
          message.type === 'user' ? (
            <UserMessage key={message.id} content={message.text} />
          ) : (
            <AiAnswer
              key={message.id}
              ref={(element) => setAnswerRef(message.id, element)}
              content={message.text}
              usedMemosCount={message.memoIds?.length ?? 0}
              onRegenerate={() => onRegenerate(message.id)}
              onSaveToMemo={() => onSaveToMemo(message.id)}
            />
          ),
        )
      )}

      {isAnswerLoading && (
        <div className={styles.loadingMessage}>
          <Icon name="ic_ai" size={24} color="grey500" />
          <span>
            {answerGeneratingMemoCount}개의 메모를 바탕으로 결과물을
            생성중이에요...
          </span>
        </div>
      )}
    </div>
  );
};

export default AiPanelChat;
